import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Link,
    Switch
} from 'react-router-dom';

import AppMenu from '../containers/app-menu.js';
import Home from '../containers/home.js';
import History from '../containers/history.js';
import Positions from '../containers/positions.js';
import Orders from '../containers/orders.js';
import Cash from '../containers/cash.js';
import Sector from '../containers/sector.js';
import Profile from '../containers/profile';
import Trending from '../containers/trending';
import PositionDetail from '../components/position-detail.js';


export default class AppLayout extends Component {

    constructor() {
        super();
        this.state = {
            route: window.location.pathname,
            drawer: false
        }
        this.toggleDrawer = this.toggleDrawer.bind(this);
    }

    toggleDrawer(show) {

        this.setState({
            drawer: show
        })
    }

    render() {

        let toggleDrawer = this.toggleDrawer;
        return (
            <div className="columns  is-gapless ss-full-ht-columns is-mobile">
                <div className={"column is-narrow " + (this.state.drawer ? "ss-drawer-show" : "ss-drawer-hide")} id='ss-drawer-menu' >
                    <AppMenu onPageSelected={this.onPageSelected} selected_menu={this.props.location.pathname} />
                </div>
                <div className="column">
                    <Switch onChange={() => {
                        this.setState({ route: window.location.pathname });
                    }}>
                        <Route exact path="/cash" render={(props) => {
                            return <Cash toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/orders" render={(props) => {
                            return <Orders toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/positions" render={(props) => {
                            return <Positions toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/sectors" render={(props) => {
                            return <Sector toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/history" render={(props) => {
                            return <History toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/profile" render={(props) => {
                            return <Profile toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/trending" render={(props) => {
                            return <Trending toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/symbol/:symbol" render={(props) => {
                            return <PositionDetail symbol={props.match.params.symbol} toggleDrawer={()=>toggleDrawer(true)} />
                        }} />
                        <Route exact path="/" component={Home} />
                    </Switch>
                </div>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/containers/app-layout.js